import { render, staticRenderFns } from "./DashboardVguard.vue?vue&type=template&id=7fc1fe4d&scoped=true"
import script from "./DashboardVguard.vue?vue&type=script&lang=js"
export * from "./DashboardVguard.vue?vue&type=script&lang=js"
import style0 from "./DashboardVguard.vue?vue&type=style&index=0&id=7fc1fe4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc1fe4d",
  null
  
)

export default component.exports